<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <config-hang>
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <input
            slot="config_hang_input_left"
            type="text"
            v-model="oldUniqueCode"
            placeholder="请输入老主机唯一码"
          />
        </config-hang>

        <config-hang>
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima.png" alt />
          <input
            slot="config_hang_input_left"
            type="text"
            v-model="newUniqueCode"
            placeholder="请输入新主机唯一码"
          />
        </config-hang>
        <div class="xiaotishi_style">小提示：更换主机，请先保证新主机已经连接到网络，并上线。（主机的状态灯常亮，即表示主机已上线）</div>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">确定并返回</div>
      </div>
    </div>
  </div>
</template>
<script>
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";
export default {
  data() {
    return {
      newUniqueCode: "",
      oldUniqueCode: ""
    };
  },
  components: {
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    jieBangHostBtnHandle() {
      ///解绑主机按钮被点击了
      /// 解绑网关接口
      // console.log(this.$route.query)
      this.$showTipsToast(9, this.serveHostData);
    },
    saveReturnBtnHandle() {
      ////保存并返回按钮被点击了
      // console.log(this.$route.query)
      ////处理一下入参
      if (this.oldUniqueCode === "") {
        this.$toast("老主机唯一码不能为空！");
        return;
      } else if (this.oldUniqueCode.length != 8) {
        this.$toast("请输入8位有效的老主机ID！");
        return;
      }
      if (this.newUniqueCode === "") {
        this.$toast("新主机唯一码不能为空！");
        return;
      } else if (this.newUniqueCode.length != 8) {
        this.$toast("请输入8位有效的新主机ID！");
        return;
      }

      /// 更换网关唯一码接口
      this.$request({
        method: "post",
        url: "/gateway/updateGatewayByGatewayId",
        data: {
          token: this.$store.state.token,
          newUniqueCode: this.newUniqueCode,
          oldUniqueCode: this.oldUniqueCode
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "更换成功", true); ////提示框
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
  }
};
</script>

<style>
</style>